import actions from './actions'
import mutations from './mutations'
import getters from './getters'

let state = {
  bugReportDialog: false
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}


// WEBPACK FOOTER //
// ./src/store/bugReport/index.js